import { render, staticRenderFns } from "./RecommendationGroupSection.vue?vue&type=template&id=64ef91a8"
import script from "./RecommendationGroupSection.vue?vue&type=script&lang=js"
export * from "./RecommendationGroupSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports